export default __webpack_public_path__ + "static/media/Group 5439.3010571f.svg";